import React, { useEffect, useState } from 'react'
import { Box, Button, Card, CardContent, Divider, Typography } from '@mui/material'
import { ChevronRight as ChevronRightIcon, Clear as ClearIcon } from '@mui/icons-material'
import { useDispatch, useSelector } from 'react-redux'
import Dialog from '@mui/material/Dialog'
import DialogActions from '@mui/material/DialogActions'
import DialogContent from '@mui/material/DialogContent'
import DialogContentText from '@mui/material/DialogContentText'
import DialogTitle from '@mui/material/DialogTitle'
import { useStyles } from './inboxStyles'
import SuccessSnackBar from '../../HOC/SuccesSnackBar'
import ErrorSnackBar from '../../HOC/ErrorSnackBar'
import { RootState } from '../../../reducers'
import { freezeCase, fetchInboxData, fetchRecentlyReleasedData } from '../../../actions'

export default function FreezeReportingDialog({ userId, open, onClose, userDetails }) {
  const classes = useStyles()
  const dispatch = useDispatch()
  const { re_freeze_success, re_freeze_error } = useSelector((state: RootState) => state.updateFreezeReportStatus)
  const [openSuccessSnackBar, setOpenSuccessSnackBar] = useState(false)
  const [openErrorSnackBar, setOpenErrorSnackBar] = useState(false)
  const [isFreeze, setFreeze] = useState(false)
  const updateDataTable = async () => {
    setOpenSuccessSnackBar(true)
    if (re_freeze_success) {
      dispatch(
        fetchInboxData({
          id: `${userId}`,
          filterField: 'created_datetime',
          filterValue: null,
          caseView: 'assigned',
          startDate: null,
          endDate: null,
          sortOrder: 'asc',
          sortField: 'created_datetime',
          pageIndex: 1,
          pageSize: 10,
        }),
      )
      dispatch(
        fetchRecentlyReleasedData({
          id: `${userId}`,
          filterField: 'case_number',
          filterValue: null,
          caseView: 'recently_released',
          startDate: null,
          endDate: null,
          sortOrder: 'asc',
          sortField: 'created_datetime',
          pageIndex: 1,
          pageSize: 10,
        }),
      )
      onClose()
    }
  }

  const handleFreezeReport = async (event, caseid: any) => {
    await dispatch(
      freezeCase({
        id: userId,
        caseid: userDetails?.case_id,
      }),
    )
    setFreeze(true)
  }

  useEffect(() => {
    if (isFreeze) {
      if (re_freeze_success) {
        updateDataTable()
      } else if (re_freeze_error) {
        setOpenErrorSnackBar(true)
        onClose()
      }
      setFreeze(false)
    }
  }, [re_freeze_success, re_freeze_error, isFreeze])

  useEffect(() => {
    setTimeout(() => setOpenErrorSnackBar(false), 1000)
    setTimeout(() => setOpenSuccessSnackBar(false), 1000)
  }, [openErrorSnackBar, openSuccessSnackBar])

  return (
    <>
      {openSuccessSnackBar && <SuccessSnackBar message="Successfully updated case status" />}
      {openErrorSnackBar && <ErrorSnackBar message="Please check the entered case identifier" />}
      <Dialog fullWidth maxWidth="md" open={open} onClose={onClose}>
        <DialogTitle className={classes.dialogTitle}>Stop the report from releasing</DialogTitle>
        <Divider />
        <DialogContent>
          <DialogContentText className={classes.dialogContent}>
            This will recall the selected case&apos;s Released status and will move the case back to your inbox.
          </DialogContentText>
        </DialogContent>
        <Card className={classes.card}>
          <CardContent className={classes.cardContent}>
            <Typography sx={{ fontSize: 14, width: '50%' }} color="text.secondary" gutterBottom>
              TRF ID: <span className={classes.contentDetails}>{userDetails?.case_number}</span>
            </Typography>
            <Typography
              sx={{
                mb: 1.5,
                width: '50%',
              }}
              color="text.secondary"
            >
              Patient:{' '}
              <span className={classes.contentDetails}>
                {userDetails?.patient_last_name}, {userDetails?.patient_first_name}
              </span>
            </Typography>
          </CardContent>
        </Card>
        <DialogActions className={classes.buttonActions}>
          <Button
            className={`${classes.btn} ${classes.buttonMargin}`}
            onClick={(event) => handleFreezeReport(event, userDetails?.case_id)}
            endIcon={<ChevronRightIcon />}
          >
            Continue
          </Button>
          <Button onClick={onClose} variant="outlined" className={classes.buttonMargin} endIcon={<ClearIcon />}>
            Cancel
          </Button>
        </DialogActions>
      </Dialog>
    </>
  )
}
